import React from 'react';
import BrowserFrame from './BrowserFrame';
import { ShieldCheck, Check, Building2, FileCheck2, Calendar } from 'lucide-react';

const TEAL = '#02857E';

const TrustScoreMockup: React.FC<{ className?: string }> = ({ className }) => (
  <BrowserFrame url="app.lanerunner.com/company/details" className={className}>
    <div className="p-5">
      <div className="rounded-xl border border-gray-200 bg-white p-5">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div
              className="h-12 w-12 rounded-xl inline-flex items-center justify-center"
              style={{ backgroundColor: `${TEAL}15` }}
            >
              <Building2 className="h-6 w-6" style={{ color: TEAL }} />
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900">Cascade Carrier Co.</div>
              <div className="text-[11px] text-gray-500">MC-784512 · DOT-2914003</div>
            </div>
          </div>
          <span
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold text-white"
            style={{ backgroundColor: TEAL }}
          >
            <ShieldCheck className="h-3 w-3" /> VERIFIED
          </span>
        </div>

        {/* trust meter */}
        <div className="mb-4">
          <div className="flex items-center justify-between text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
            <span>Trust Score</span>
            <span style={{ color: TEAL }}>92 / 100</span>
          </div>
          <div className="h-1.5 rounded-full bg-gray-100 overflow-hidden">
            <div className="h-full rounded-full" style={{ width: '92%', backgroundColor: TEAL }} />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2">
          {[
            { icon: Check, label: 'FMCSA Authority Active' },
            { icon: Check, label: 'Insurance On File' },
            { icon: FileCheck2, label: 'Documents Reviewed' },
            { icon: Calendar, label: 'Authority Age 7 yrs' },
          ].map((r) => {
            const Icon = r.icon;
            return (
              <div
                key={r.label}
                className="flex items-center gap-2 px-2.5 py-2 rounded-lg bg-gray-50 border border-gray-100"
              >
                <span
                  className="h-5 w-5 rounded-full inline-flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: `${TEAL}20` }}
                >
                  <Icon className="h-3 w-3" style={{ color: TEAL }} />
                </span>
                <span className="text-[11px] font-medium text-gray-700 truncate">{r.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </BrowserFrame>
);

export default TrustScoreMockup;
